
import {html} from "lit"
import {Valuable} from "@e280/strata"
import {shadow, useCss, useName} from "@e280/sly"
import {unsafeHTML} from "lit/directives/unsafe-html.js"

import stylesCss from "./styles.css.js"
import themeCss from "../../theme.css.js"

import {CountdownView} from "../countdown/view.js"
import {Timelink} from "../../../logic/timelink.js"
import {markdown} from "../../../tools/markdown.js"
import {getLocalTime, getLocalTimezone, getUniversalTime} from "../../../logic/timekeeper.js"

export const TimeView = shadow(($timelink: Valuable<Timelink>) => {
	useName("time")
	useCss(themeCss, stylesCss)

	const timelink = $timelink()
	const content = timelink.text
		? markdown(timelink.text)
		: undefined

	const timezone = getLocalTimezone()
	const local = getLocalTime(timelink.time)
	const universal = getUniversalTime(timelink.time)

	return html`
		<div class=timeframe>
			<h1 class="local casual">
				<span>
					<span class=weekday>${local.weekdayName}</span>
					<span class=time>${local.hour12}:${local.minutePad} ${local.ampm},</span>
					<span class=day>${local.monthName} ${local.day}</span>
				</span>
			</h1>
			<span class="local precise" title="${timezone.long} (${timezone.offset})">
				${timezone.short} ${local.year}-${local.monthPad}-${local.dayPad} ${local.hourPad}:${local.minutePad}
			</span>
			<span class="universal precise">
				UTC ${universal.year}-${universal.monthPad}-${universal.dayPad} ${universal.hourPad}:${universal.minutePad}
			</span>
			<span class=countdown>
				${CountdownView($timelink)}
			</span>
		</div>

		${content ? html`
			<div class=markdown theme-markdown>
				${unsafeHTML(content)}
			</div>
		` : undefined}
	`
})
